import { PeriodoAnualDatePicker } from './periodo_anual_date_picker';

import CascateList from "../../../../../../common/components/cascate_list"
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DefaultInput from "../../../../../../common/components/default_input";

/**
 * Header
 */

type Props = {
  dataDe: Date | null;
  dataAte: Date | null;
  cor: string | null;
  onDataChange: (de: Date | null, ate: Date | null) => void;
  onCorChange: (cor: string) => void;
  onClearFilters: () => void;
};

export const Header = ({
  dataDe,
  dataAte,
  cor,
  onDataChange,
  onCorChange,
  onClearFilters,
}: Props) => {
  return (
    <CascateList title="Filtros" defaultOpen={true}>
      <div className="w-full flex flex-col gap-2">
        <div className="w-full grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 gap-2">
          <PeriodoAnualDatePicker
            label="Período de (dia/mês)"
            value={dataDe}
            onChange={value => { if (!value || !Number.isNaN(value.getTime())) onDataChange(value, dataAte); }}
          />
          <PeriodoAnualDatePicker
            label="Período até (dia/mês)"
            value={dataAte}
            onChange={value => { if (!value || !Number.isNaN(value.getTime())) onDataChange(dataDe, value); }}
          />

          <DefaultInput
            name="cor"
            label="Cor"
            value={cor}
            onChangeValue={onCorChange}
          />
        </div>

        <div className="w-full flex justify-end">
          <div className="w-[180px]">
            <PrimaryButton
              startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
              buttonColor="yellow"
              onClick={onClearFilters}>
              Limpar filtros
            </PrimaryButton>
          </div>
        </div>
      </div>
    </CascateList>
  );
}
